module.exports = __webpack_public_path__ + "img/us.19409127.svg";